import { colors } from '../theme';

export type AwareClassification = 'VERDE' | 'ARANCIONE' | 'ROSSO' | 'NO CLASS';

export const getAwareColor = (classId: string): string => {
  const normalized = classId.trim().toUpperCase();
  
  switch (normalized) {
    case 'VERDE':
      return colors.aware.access;
    case 'ARANCIONE':
      return colors.aware.watch;
    case 'ROSSO':
      return colors.aware.reserve;
    case 'NO CLASS':
    default:
      return colors.aware.unclassified;
  }
};

export const getAwareLabel = (classId: string): string => {
  const normalized = classId.trim().toUpperCase();
  
  switch (normalized) {
    case 'VERDE':
      return 'Access';
    case 'ARANCIONE':
      return 'Watch';
    case 'ROSSO':
      return 'Reserve';
    case 'NO CLASS':
    default:
      return 'Non classificato';
  }
};
